import { useEffect, useState } from 'react';
import { load } from 'recaptcha-v3';


export async function loadRecaptcha() {
	return load('6LcdjZ4UAAAAAK6Uka0XC_BuaaI6JcB7Q_14WKkJ', {
		autoHideBadge: true,
	});
}

export async function executeRecaptcha() {
	const recaptcha = await loadRecaptcha();
	return recaptcha.execute('login');
}

export const useRecaptcha = () => {
	const [recaptchaToken, setRecaptchaToken] = useState('');
	useEffect(() => {
		const getToken = async () => executeRecaptcha().then((token: string) => setRecaptchaToken(token));
		getToken();
	}, []);
	return { recaptchaToken };
};

export const Recaptcha = {
	loadRecaptcha,
	executeRecaptcha,
	useRecaptcha,
};
